import { ESortOrder } from "@domains/utils/sort";
import React, { useState } from "react";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/MobSortDrop.scss";
const CommonSortDropMob = ({ OrderBy, setOrderBy, sortByFilters, setSortByFilters, sortKeyDisplayState, sortByFunction, resetSort, }) => {
    const [sortState, setSortState] = useState(sortByFilters);
    const [id, setId] = useState(0);
    const setSortOrder = (idx, key, value) => {
        setId(idx);
        let tempData = sortState.map((val) => {
            return Object.assign({}, val);
        });
        tempData[idx].order = value === ESortOrder.DESC ? ESortOrder.ASC : ESortOrder.DESC;
        tempData = tempData.map((value, id) => {
            if (id !== idx)
                value.order = ESortOrder.UNCHANGED;
            return value;
        });
        setSortState(tempData);
    };
    return (React.createElement("div", { className: "mob-sort-drop" },
        React.createElement("div", { className: "mob-sort-drop-head" },
            React.createElement("div", { className: "down-bar container" },
                React.createElement("span", { className: "down-bar-left" }, "Sorting"),
                React.createElement("input", { onClick: resetSort, className: "down-bar-right", type: "button", value: "Reset" }))),
        React.createElement("div", { className: "mob-sort-drop-body" },
            React.createElement("ul", { className: "sort-drop-bodylist" }, sortState.map((val, idx) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("li", { key: idx, onClick: () => setSortOrder(idx, val.displayName, val.order), className: sortState[idx].order === 0 ? "dark-grey" : "light-blue" },
                        React.createElement("label", null, val.displayName),
                        React.createElement("span", { className: "bodylist-right" },
                            React.createElement("p", { className: "light-right " + (sortState[idx].order === 0 ? "light-grey" : "light-blue") },
                                " ",
                                sortKeyDisplayState[val.displayName][val.order === ESortOrder.ASC ? "asc" : "desc"]),
                            val.order == ESortOrder.ASC ? (React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-point-arrow-up" }))) : (React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-point-arrow-down" }))))),
                    idx == sortByFilters.length - 1 ? null : React.createElement("div", { className: "border-seperator" })));
            }))),
        React.createElement("div", { className: "mob-sort-drop-footer" },
            React.createElement("input", { type: "button", value: "Apply Sorting", onClick: () => sortByFunction(id, sortState) }))));
};
export default CommonSortDropMob;
